<div class="curve-animation">
  <svg width="906" height="362" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_2052_32247" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="18" y="18" width="870"
      height="155">
      <path
        d="M886 171C737 171 700.5 20 659.5 20C618.5 20 574.5 171 480.5 171C386.5 171 340.5 75.5 253 75.5C165.5 75.5 130.912 156.5 20 156.5"
        stroke="url(#paint0_radial_2052_32247)" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
    </mask>
    <g mask="url(#mask0_2052_32247)">
      <rect x="-846.5" y="16" width="866" height="160" fill="url(#paint1_radial_2052_32247)" />
    </g>
    <mask id="mask1_2052_32247" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="18" y="189" width="870"
      height="155">
      <path class="path"
        d="M886 342C737 342 700.5 191 659.5 191C618.5 191 574.5 342 480.5 342C386.5 342 340.5 246.5 253 246.5C165.5 246.5 130.912 327.5 20 327.5"
        stroke="url(#paint2_radial_2052_32247)" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
    </mask>
    <g mask="url(#mask1_2052_32247)">
      <rect x="19.5" y="187" width="866" height="160" fill="url(#paint3_radial_2052_32247)" />
    </g>
    <defs>
      <radialGradient id="paint0_radial_2052_32247" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
        gradientTransform="translate(557.5 38.5) rotate(90.5807) scale(148.008 1099.58)">
        <stop stop-color="white" />
        <stop offset="0.317708" stop-color="white" stop-opacity="0.72" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </radialGradient>
      <radialGradient id="paint1_radial_2052_32247" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-518 156.397) rotate(-89.452) scale(156.828 1099.59)">
        <stop stop-color="#0E101B" />
        <stop offset="0.734375" stop-color="#375EC0" />
        <stop offset="1" stop-color="#8AABFF" stop-opacity="0" />
      </radialGradient>
      <radialGradient id="paint2_radial_2052_32247" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
        gradientTransform="translate(557.5 209.5) rotate(90.5807) scale(148.008 1099.58)">
        <stop stop-color="white" />
        <stop offset="0.317708" stop-color="white" stop-opacity="0.72" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </radialGradient>
      <radialGradient id="paint3_radial_2052_32247" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
        gradientTransform="translate(348 327.397) rotate(-89.452) scale(156.828 1099.59)">
        <stop stop-color="#0E101B" />
        <stop offset="0.734375" stop-color="#375EC0" />
        <stop offset="1" stop-color="#8AABFF" stop-opacity="0" />
      </radialGradient>
    </defs>
  </svg>
</div>
